<script setup>
import { ref } from 'vue'

// An OpenAI suggestion that is not on RM yet (RM-288, Kapil 2026-09-15): its
// name at the list's dense scale with a heart beside it — the same gesture
// as an RM row. Tapping the heart asks the agent to add the place (Google-
// linked when Google has it, unlinked otherwise) and favorite it; the heart
// fills at once so the tap reads immediately, and the agent confirms in one
// line. There is no favorite count: nobody on RM has it yet.

const props = defineProps({
  name: { type: String, required: true },
  city: { type: String, default: '' },
  website: { type: String, default: '' },
  active: { type: Boolean, default: true },
})

const emit = defineEmits(['add'])

const added = ref(false)

function add() {
  if (added.value || !props.active) return
  added.value = true
  emit('add', { name: props.name, city: props.city, website: props.website })
}
</script>

<template>
  <div class="agent-ai-place">
    <span class="agent-ai-place__name">{{ name }}</span>
    <button
      type="button"
      class="agent-ai-place__heart"
      :class="{ 'agent-ai-place__heart--on': added }"
      :aria-label="added ? `${name} added to your favorites` : `Add ${name} to your favorites`"
      :aria-pressed="added ? 'true' : 'false'"
      @click.stop="add"
    >
      <VIcon
        :icon="added ? 'mdi-heart' : 'mdi-heart-outline'"
        size="16"
        :color="added ? 'primary-dark' : undefined"
      />
    </button>
  </div>
</template>

<style scoped>
/* Same line geometry as the RM row's title line (name + heart unit) */
.agent-ai-place {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 2px;
  min-width: 0;
  max-width: 460px;
}

.agent-ai-place__name {
  min-width: 0;
  font-family: var(--ds-font-heading);
  font-size: 17px;
  font-weight: var(--ds-font-medium);
  line-height: 1.2;
  color: var(--ds-brand-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-ai-place__heart {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  padding: 4px;
  border: 0;
  background: none;
  color: var(--ds-brand-primary-dark);
  cursor: pointer;
}

.agent-ai-place__heart--on {
  cursor: default;
}
</style>
